import React from "react"
import * as styles from "./page.module.css"

export default function Page(props) {
    return (
        <div className={styles.page}>
            <a name="top"/>
            {props.children}
        </div>
    )
} 